var fontFamily = 'cerapro';
var fontSize = 16;
var typography = {
  htmlFontSize: fontSize,
  fontSize: fontSize,
  fontFamily: fontFamily,
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: 700
  },
  h2: {
    fontSize: '32px',
    lineHeight: '32px',
    fontWeight: 900
  },
  h3: {
    fontSize: '26px',
    lineHeight: '32px',
    fontWeight: 500
  },
  h4: {
    fontSize: '24px',
    lineHeight: '26px',
    fontWeight: 500
  },
  h5: {
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: 500
  },
  h6: {
    fontSize: '18px',
    lineHeight: '20px',
    fontWeight: 500
  },
  body1: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 400
  },
  caption: {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 400
  },
  mini: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400
  },
  micro: {
    fontSize: '10px',
    lineHeight: '16px',
    fontWeight: 400
  }
};
export { typography };